// Thin deposit-funnel analytics for the GCC cashier redesign. No-op-safe: it
// pushes to the app's existing window.dataLayer / window.gtag when present and
// silently drops otherwise. No new tracking dependency is introduced, and a
// throw here can never break the cashier.
function emit(name, payload) {
  try {
    if (typeof window === "undefined") return;
    const event = "gcc_cashier_" + name;
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...(payload || {}) });
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", event, payload || {});
    }
  } catch (e) {
    // analytics must never interrupt the deposit flow
  }
}

const analytics = {
  depositStarted: (p) => emit("deposit_started", p),
  categorySelected: (p) => emit("category_selected", p),
  methodSelected: (p) => emit("method_selected", p),
  amountSet: (p) => emit("amount_set", p),
  bonusSelected: (p) => emit("bonus_selected", p),
  depositSubmitted: (p) => emit("deposit_submitted", p),
  depositResult: (p) => emit("deposit_result", p),
};

export default analytics;
